module.exports = __webpack_public_path__ + "img/simplified-residence-medium.07b18cb4.png";